var MANIFEST_THEMES = {
  holiday: {
    hashed: 'holiday.bfaaf20686c40a2f246256b07ddf9bf4.min.css',
    versioned: 'holiday.min.css'
  }
};
export { MANIFEST_THEMES };